import AddressFilter from "components/filters/Filters/AddressFilter";
import { ContactSortFilter } from "components/filters/Filters/SortFilter";
import CultureFilter from "components/filters/Filters/CultureFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import React from "react";
import OnlyMySelectionFilter from "components/filters/Filters/OnlyMySelectionFilter";

interface FiltersProps {
  initialTags: server.dto.TagSmall[]
  initialStatuses: server.dto.StatusSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter
      label={RESX.GeneralLabels.Search}
      title={RESX.GeneralLabels.Search}
      placeholder={RESX.GeneralLabels.Search}
    />
    <TagFilter initialTags={props.initialTags} mainArea="company" />
    <AddressFilter />
    {props.initialStatuses.length > 1 && (
      <StatusFilter initialStatuses={props.initialStatuses} />)}
    <OwnersFilter />
    <CultureFilter />
    <ContactSortFilter />
    <OnlyMySelectionFilter />
  </>;
};

export default Filters;